import { jsx } from "react/jsx-runtime";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { validateTidalLicense } from "../../base/index.js";
function NotInterested(props) {
  return /* @__PURE__ */ jsx(
    NotInterestedIcon,
    {
      "data-testid": "NotInterested",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "NotInterested",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
NotInterested.tidalIconMeta = {
  categories: "cancel,informative",
  name: "NotInterested"
};
validateTidalLicense();
export {
  NotInterested
};
//# sourceMappingURL=NotInterested.js.map
